export default __webpack_public_path__ + "static/B0071-38a19edf6150f4f8a80e986e6011701b.png";